export default function isValidURL(string: string) {
  const res = string.match(
    /^https:\/\/[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,63}(:[0-9]{1,5})?(\/.*)?$/i
  );

  return res !== null;
}
